import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Jasne Granty</h4>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>
                <Link to="/#services">
                  Profesjonalne wsparcie w pozyskiwaniu finansowania dla
                  organizacji pozarządowych, samorządów i przedsiębiorstw.
                </Link>
              </li>{" "}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Usługi</h4>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>
                <Link to="/#services">Wnioski Grantowe</Link>
              </li>
              <li>
                <Link to="/#services">Biznesplany</Link>
              </li>
              <li>
                <Link to="/#services">Doradztwo</Link>
              </li>
              <li>
                <Link to="/#services">Szkolenia</Link>
              </li>
              <li>
                <Link to="/#services">Zarządzanie Projektami</Link>
              </li>
              <li>
                <Link to="/#services">Fundraising</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Przydatne Linki</h4>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/polityka-prywatnosci">Polityka Prywatności</Link>
              </li>
              <li>
                <Link to="/regulamin">Regulamin</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Kontakt</h4>
            <div style={{ lineHeight: "1.8" }}>
              <div>
                <i
                  className="fas fa-envelope"
                  style={{
                    marginRight: "8px",
                    color: "var(--secondary-color)",
                  }}
                ></i>
                <a href="mailto:kontakt@jasnegranty.pl">
                  kontakt@jasnegranty.pl
                </a>
              </div>
              <div>
                <i
                  className="fas fa-phone"
                  style={{
                    marginRight: "8px",
                    color: "var(--secondary-color)",
                  }}
                ></i>
                <a href="tel:+48123456789">+48 123 456 789</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Jasne Granty. Wszelkie prawa zastrzeżone.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
